import '../pages/Footer';
import Footer from "./Footer";
import about_banner from "../images/about_banner.jpg";
import './pages.css';
const Trading =() => {
    return (
        <div>
            <img
                src={ about_banner }
                width="1518 px"
                height="445 px"
                alt="avatar"
            />
        <div style={ { textAlign : "center" } }>
            <p>At Vanadium, we deal with various metals from across the globe including; ferrous & non-ferrous scrap, ferroalloys, copper, aluminium, base <br /> and minor metals and minerals. With a well-defined global footprint, We have access and exposure to every kind of markets, commodities <br /> and geographies. Our easy access to raw materials and intermediates used in various manufacturing processes makes us one of the most <br /> preferred suppliers globally.

                Vanadium is driven by the philosophy of “Being Ethical First” for its stakeholders at both the ends of the <br /> supply chain by partnering with them, with a continuous focus on building mutually beneficial long-term supplier and client <br />relationships.

                Our global experience, multicultural competencies and extensive technical expertise has driven <br /> our quick yet relentless growth throughout the years.</p>
<br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />

        </div >
            <div>
            <Footer />
            </div>
        </div>
    )
};
export default Trading;
